import { connect } from 'react-redux'
import Login from './Login'
import { push } from 'react-router-redux'

const stateToProps = () => ({})

const dispatchToProps = {
  push,
}

export default connect(stateToProps, dispatchToProps)(Login)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/Login/Login.container.js